import './FormulaFieldMetaData.scss';
import { CodeHighlight } from '@ui/general';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { PeriscopeSfFormulaFieldMetadata } from '@sonar-software/sonar-ts-types';
import React from 'react';
import { SonarText } from '@ui/text';

export type FormulaFieldMetaDataProps = {
	index: number;
	formulaFieldMetaData?: PeriscopeSfFormulaFieldMetadata;
};

export const FormulaFieldMetaData: React.FC<FormulaFieldMetaDataProps> = ({ index, formulaFieldMetaData }) => {
	if (!formulaFieldMetaData) {
		return null;
	}

	return (
		<div className='formula-field-meta-data'>
			<SonarText weight='semibold'>
				{ COPY_SPECIFIC.FORMULA_REFERENCES_FIELDS.replace(
					'{0}',
					String(formulaFieldMetaData.codeReferences?.length)
				) }
			</SonarText>
			<CodeHighlight
				code={ formulaFieldMetaData.code }
				codeReferences={ formulaFieldMetaData.codeReferences }
				index={ index } />
		</div>
	);
};
